/**
 * @desc 门店信息
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** order_no */
  order_no: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.StoreCommonDTO>>(
    `/storeapi/inner/store`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.StoreCommonDTO>;
export default req;
